<template>
  <v-dialog v-model="dialog" persistent fullscreen>
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">mdi-receipt</v-icon>
          </template>
          <span>{{ $t("extract") }} </span>
        </v-tooltip>
      </v-btn>
    </template>

    <v-toolbar>
      <v-toolbar-title>{{ $t("extractAgent") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="[(dialog = !dialog)]"
        ><v-icon>mdi-close</v-icon></v-btn
      >
    </v-toolbar>

    <v-card>
      <div class="px-2 pt-4">
        <div class="pb-4 px-3">
          <div class="title">
            <span class="grey--text">{{ $t("agent") }}:</span>
            {{ agent.agentName }}
          </div>
          <div class="title">
            <span class="grey--text">Id:</span> {{ agent.agentId }}
          </div>
        </div>
        <Range />
        <div class="mx-2 mb-3">
          <GroupExport />
        </div>
      </div>
      <v-card-actions class="px-4 pt-0">
        <v-spacer></v-spacer>
        <v-btn class="info" small @click="balanceAgent()" :disabled="progress">
          <v-icon small left>mdi-filter</v-icon>Filtrar
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <div>
        <div id="print-report-extract">
          <!-- Print Only -->
          <div class="caption d-none d-print-block mb-3">
            <HeaderPrint />
          </div>
          <!-- end/ Print Only -->
          <v-card elevation="0">
            <div class="pa-3 py-0">
              <v-row class="align-center">
                <v-col cols="'12" md="9">
                  <v-btn
                    small
                    class="white black--text d-print-none"
                    @click="$printReportExtract()"
                  >
                    <v-icon small left>mdi-printer</v-icon>
                    {{ $t("print") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="text-right">
                    {{ $t("previousBalance") }}:
                    <v-chip class="ml-1">R$ {{ previusBalance }}</v-chip>
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t("date") }}</th>
                    <th class="text-left">{{ $t("salesQty") }}</th>
                    <th class="text-left">{{ $t("verified") }}</th>
                    <th class="text-left">{{ $t("commission") }}</th>
                    <th class="text-left">{{ $t("canceled") }}</th>
                    <th class="text-left">{{ $t("awards") }}</th>
                    <th class="text-left">{{ $t("rights") }}</th>
                    <th class="text-right">{{ $t("dayBalance") }}</th>
                    <th class="text-right">{{ $t("finalBalance") }}</th>
                  </tr>
                </thead>
                <tbody class="extract-table">
                  <tr v-for="item in extract" :key="item.date_entry">
                    <td class="text-left">{{ item.date_entry }}</td>
                    <td class="text-left">{{ item.count }}</td>
                    <td class="text-left" v-html="handleValue(item.sales)"></td>
                    <td
                      class="text-left"
                      v-html="handleValue(item.commission)"
                    ></td>
                    <td
                      class="text-left"
                      v-html="handleValue(item.cancellations)"
                    ></td>
                    <td
                      class="text-left"
                      v-html="handleValue(item.prizes_paid)"
                    ></td>
                    <td class="text-left" v-html="handleValue(item.deals)"></td>
                    <td
                      class="text-right"
                      v-html="handleValue(item.balance)"
                    ></td>
                    <td
                      class="text-right"
                      v-html="handleValue(item.balance_final)"
                    >
                      <!-- {{ item.balance_final | handlerNaN }} -->
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <div v-show="progress" class="text-center pa-4">
              <v-progress-circular indeterminate></v-progress-circular>
            </div>

            <v-alert class="ma-4" v-show="alert" type="warning" dense outlined>
              {{ $t("noDrivesFount") }} {{ $t("filterFrom") }}
              {{ rangeDate.data_final | formatDateUi }}{{ $t("until") }}
              {{ rangeDate.data_final | formatDateUi }}
            </v-alert>
          </v-card>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Range from "@/components/common/filters/Range.vue";
import GroupExport from "@/components/common/filters/GroupExport.vue";
import HeaderPrint from "@/components/common/header-print";

export default {
  components: { Range, GroupExport, HeaderPrint },
  name: "administrator-financial-balance-agent",
  props: ["agent"],
  data: () => ({
    dialog: false,
    alert: false,
    progress: false,
    extract: [],
    previusBalance: "",
    loading: false,
  }),
  mounted() {},
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },
  watch: {},
  methods: {
    async balanceAgent() {
      this.progress = true;
      this.alert = false;
      this.extract = [];

      const body = {
        ...this.rangeDate,
        id_agent: this.agent.agentId,
        export: this.exportDoc,
      };

      let response;

      // Request Download DOC (Excel)
      if (this.exportDoc) {
        const extension = this.exportDoc;
        await this.$request.exportDoc(
          "/administrator/financial/balanceAgent",
          body,
          extension,
          this.rangeDate
        );
        this.progress = false;
      } else {
        response = await this.$request.post(
          "/administrator/financial/balanceAgent",
          body
        );
      }

      if (response.length != 0) {
        this.previusBalance = this.decimalAdjustment(response.dados.balance);
        const resultExtract = response.dados.extract;
        this.buildExtract(this.previusBalance, resultExtract);
      } else {
        this.extract = [];
        this.alert = true;
      }

      this.progress = false;
    },

    buildExtract(previousBalance, resultExtract) {
      let extract = [];
      let balance_final = previousBalance;

      let sum = {
        date_entry: "Total",
        count: 0,
        sales: 0,
        commission: 0,
        cancellations: 0,
        prizes_paid: 0,
        deals: 0,
        balance: 0,
        balance_final: 0,
      };

      resultExtract.forEach((element) => {
        // sum balance final
        balance_final = Number(element.balance) + Number(balance_final);
        // date treatment
        var dateVal = element.date_entry;
        var date = new Date(`${dateVal}T00:00:00.000`).toLocaleDateString();

        // Assemble item (Row)
        const item = {
          date_entry: date,
          count: element.count,
          sales: element.sales,
          commission: element.commission,
          cancellations: element.cancellations,
          prizes_paid: element.prizes_paid,
          // conditional powerball
          // powerball: element.powerball,
          // cancellations_powerball: element.cancellations_powerball,
          // commission_powerball: element.commission_powerball,
          // prize_powerball: element.prize_powerball,
          deals: element.deals,
          balance: element.balance,
          balance_final: this.decimalAdjustment(balance_final),
        };
        extract.push(item);

        // Sum All Items
        sum.count = sum.count += Number(element.count);
        sum.sales = this.decimalAdjustment(sum.sales + Number(element.sales));
        sum.commission = this.decimalAdjustment(
          sum.commission + Number(element.commission)
        );
        sum.cancellations = this.decimalAdjustment(
          sum.cancellations + Number(element.cancellations)
        );
        sum.prizes_paid = this.decimalAdjustment(
          sum.prizes_paid + Number(element.prizes_paid)
        );
        sum.deals = this.decimalAdjustment(sum.deals + Number(element.deals));
        sum.balance = this.decimalAdjustment(
          sum.balance + Number(element.balance)
        );
        sum.balance_final = this.decimalAdjustment(balance_final);
      });

      extract.push(sum);
      this.extract = extract;
    },

    // Ajust decimal
    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },

    showDialog() {
      this.$store.commit("showDialog", true);
    },

    handleValue(val, count) {
      // Se for Count tirar o decimal:
      if (count == "count") {
        if (val.match(/^-?\d+\.\d+$/) != null) {
          return `<span class='white--text'>${val.slice(0, -3)}</span>`;
        }
        return val;
      }
      // Tratamento de cores:
      if (val > 0) return `<span class='green--text'>${val}</span>`;
      if (val < 0) return `<span class='red--text'>${val}</span>`;
      return val;
    },
  },

  filters: {
    handlerNaN: function(x) {
      if (isNaN(x)) {
        return 0;
      }
      return x;
    },
    formatDateUi: function(val) {
      var date = new Date(val).toLocaleDateString();
      return date;
    },
  },
};
</script>
<style scoped>
tbody.extract-table tr:last-child {
  text-transform: uppercase;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.1);
}
</style>
